// extracted by mini-css-extract-plugin
export default {"openedColor":"ArrowButton_openedColor__5BeJS","default":"ArrowButton_default__6GKBm"};